import { render, staticRenderFns } from "./NutritionTable.vue?vue&type=template&id=844e8b02&scoped=true"
import script from "./NutritionTable.vue?vue&type=script&lang=js"
export * from "./NutritionTable.vue?vue&type=script&lang=js"
import style0 from "./NutritionTable.vue?vue&type=style&index=0&id=844e8b02&prod&lang=scss&scoped=true"
import style1 from "./NutritionTable.vue?vue&type=style&index=1&id=844e8b02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844e8b02",
  null
  
)

export default component.exports